import LoteService from "./LoteService";

/**
 * @deprecated in favor of typescript conversion: livestockServiceMixin.ts
 * - when `listaLotesPasto` operation is migrated, remove this class too
 */
export class LoteManager {
  async obterLotesPasto(idPasto) {
    const respostaService = await LoteService.listaLotesPasto(idPasto);
    return respostaService.data;
  }
}

export default new LoteManager();
